var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn_wrap_left"},[_c('span',{staticClass:"bar"}),_c('button',{attrs:{"id":"batchSaleStatusType","type":"button"},on:{"click":_vm.onClickBatchJudgment}},[_vm._v(_vm._s(_vm.$t('PRODUCT_PRODUCT_JUDGEMENT_BATCH')))])])}
var staticRenderFns = []

export { render, staticRenderFns }